import React, { useState } from 'react';

const Toggle = ({
  onToggle,
  disabled,
  value,
  label = '',
  onText = 'ON',
  offText = 'OFF',
  isInHeader = false,
  noMargin,
  isAsync
}) => {
  const [active, setActive] = useState(value);

  const handleToggle = () => {
    setActive(!active);
    onToggle(!value);
  };

  const handleAsyncToggle = () => {
    onToggle(!value);
    // do nothing else, a reload will force the new value
    return;
  };

  return (
    isInHeader ? (
      <div className='refresh-toggle in-header'>
        <span>{label} </span>
        <button
          type='button'
          disabled={disabled}
          className={!active ? 'button toggled-off' : 'button'}
          onClick={() => handleToggle()}
        >
          {active ? onText : offText}
          <span className='refresh-toggle-switch' />
        </button>
      </div>
    ) : (
      <div className='refresh-toggle' style={{ margin: noMargin ? 0 : 'auto' }}>
        {label ? (
          <span className='label' style={{ marginBottom: '.5rem' }}>{label}</span>
        ) : null}
        <button
          type='button'
          disabled={disabled}
          className={!active ? 'button toggled-off' : 'button'}
          onClick={() => {
            if (isAsync) {
              handleAsyncToggle();
            } else {
              handleToggle();
            }
          }}
        >
          {active ? onText : offText}
          <span className='refresh-toggle-switch' />
        </button>
      </div>
    )
  );
};

export default Toggle;
